export default __webpack_public_path__ + "static/media/ic_location.8f743b6d.svg";